// Translation for en
export const vi = {
        common: {
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            delete: 'Delete',
            edit: 'Edit',
            activate: 'Activate',
            add: 'Add',
            saving: 'Saving...',
            loading: 'Loading...',
            active: 'ACTIVE',
            inUse: 'In Use',
            test: 'Test',
            searchApps: 'Search apps...',
            betaBanner: 'BETA - Service not available yet!'
        },
        header: {
            creditBalance: 'Balance',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Sign In',
            signUp: 'Sign Up',
            username: 'Username',
            password: 'Password',
            continue: 'Continue',
            noAccount: 'Don\'t have an account?',
            hasAccount: 'Already have an account?',
            loginError: 'Login failed',
            invalidCredentials: 'Invalid username or password',
            rateLimited: 'Too many login attempts. Please wait a moment.',
            sessionExpired: 'Your session has expired. Please use a new magic link.',
            magicLinkInvalid: 'The login link is invalid or has expired.',
            magicLinkSuccess: 'Welcome! You have been successfully logged in.',
            magicLinkProcessing: 'Processing login...',
            connectionError: 'Connection error. Please try again.'
        },
        profile: {
            myProgress: 'My Learning Progress',
            signOut: 'Sign Out',
            plan: 'Plan: '
        },
        settings: {
            title: 'Settings',
            tabs: {
                uiSettings: 'UI Settings',
                systemPrompt: 'System Prompt',
                llmProfiles: 'LLM Profiles',
                ttsProfiles: 'TTS Profiles',
                language: 'Language',
            },
            uiSettings: {
                title: 'User Interface',
                themeMode: 'Theme Mode',
                darkMode: 'Dark Mode',
                lightMode: 'Light Mode',
                themeColor: 'Theme Color',
                themeColorDesc: 'Choose the accent color for buttons, icons and highlights',
                background: 'Background',
                backgroundDesc: 'Choose a background for your workspace',
                selectBackgroundColor: 'Select Background Color',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Focus',
                    concentration: 'Concentration',
                    relaxation: 'Relaxation',
                    lianas: 'Lianas',
                    color: 'Color'
                },
                backgroundColors: {
                    deepDark: 'Deep Dark',
                    darkGrey: 'Dark Grey',
                    midnightBlue: 'Midnight Blue',
                    indigo: 'Indigo',
                    darkTeal: 'Dark Teal',
                    brown: 'Brown',
                    darkRed: 'Dark Red',
                    deepPurple: 'Deep Purple',
                    pureWhite: 'Pure White',
                    softWhite: 'Soft White',
                    lightGrey: 'Light Grey',
                    paleBlue: 'Pale Blue',
                    paleGreen: 'Pale Green',
                    paleOrange: 'Pale Orange',
                    lavender: 'Lavender',
                    blueGrey: 'Blue Grey'
                }
            },
            systemPrompt: {
                label: 'System Prompt:',
                placeholder: 'Loading system prompt...',
                emptyError: 'System prompt cannot be empty!',
                saveSuccess: '✓ System prompt saved successfully!',
                loadError: 'Error loading system prompt',
                saveError: 'Error saving'
            },
            llmProfiles: {
                addButton: '+ Add New Connection',
                newConnection: 'New Connection',
                editConnection: 'Edit Connection',
                emptyState: 'No LLM connections available. Click below to add one.',
                loadingProfiles: 'Loading profiles...',
                nameLabel: 'Name *',
                namePlaceholder: 'e.g. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ Profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                profileNotFound: 'Profile not found!',
                loadError: 'Error loading profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Add New Voice',
                newVoice: 'New Voice',
                editVoice: 'Edit Voice',
                emptyState: 'No TTS profiles available. Click below to add one.',
                loadingProfiles: 'Loading TTS profiles...',
                nameLabel: 'Name',
                namePlaceholder: 'e.g. My ElevenLabs Adam',
                providerLabel: 'Provider',
                providerPlaceholder: 'e.g. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model ID *',
                modelIdPlaceholder: 'e.g. eleven_monolingual_v1',
                voiceIdLabel: 'Voice ID',
                voiceIdPlaceholder: 'e.g. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ TTS profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                loadError: 'Error loading TTS profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting'
            },
            language: {
                title: 'Choose Language',
                description: 'Select your preferred language for the user interface'
            },
        },
        chat: {
            ready: 'Ready',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Click START for real-time conversation.',
            listening: 'Listening...',
            speaking: 'Thorsten is speaking...',
            userLabel: 'You',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Type a message...',
            send: 'Send',
            loginRequired: 'Please sign in to use this service.',
            loginButton: 'Sign In Now',
            magicLinkRequired: 'Please use a magic link to sign in.',
            creditLimitError: 'Your hourly quota has been exhausted. Please upgrade your plan (Medium/Premium) to continue.',
            serviceDisabled: 'Dịch vụ trò chuyện hiện không khả dụng. Vui lòng thử lại sau.'
        },
        notifications: {
            error: 'Error',
            success: 'Success',
            info: 'Information',
            unknownError: 'An unknown error occurred'
        },
        cookie: {
            message: 'This website uses cookies to provide you with the best possible user experience.',
            accept: 'Accept'
        },
        curriculum: {
                buttonLabel: 'Chương trình học',
                buttonTitle: 'Hiển thị nội dung chương trình học',
                modalTitle: 'Chương trình học {app}',
                sections: {
                    topic: 'Chủ đề chương trình học',
                    explanation: 'Giải thích thân thiện với trẻ em',
                    studentProfile: 'Hồ sơ học sinh'
                },
                topic: {
                    empty: 'Không có chủ đề chương trình học nào được liên kết với ứng dụng nhỏ này trong hệ thống.',
                    missingDetail: 'Dữ liệu chương trình học chi tiết cho ứng dụng nhỏ này chưa có sẵn trong hệ thống.',
                    learningGoals: 'Mục tiêu học tập',
                    prerequisites: 'Điều kiện tiên quyết',
                    unitLabel: 'Bài học',
                    durationLabel: 'Thời lượng',
                    difficultyLabel: 'Độ khó',
                    hours: 'giờ',
                    minutes: 'phút'
                },
                explanation: {
                    empty: 'Không có giải thích thân thiện với trẻ em.',
                    loadingPrepare: 'AI đang chuẩn bị giải thích',
                    loadingExplain: 'AI đang giải thích chủ đề bằng ngôn ngữ thân thiện với trẻ em',
                    requestFailed: 'Không thể tạo giải thích thân thiện với trẻ em.'
                },
                studentProfile: {
                    country: 'Quốc gia',
                    region: 'Bang / Vùng',
                    schoolType: 'Loại trường',
                    grade: 'Lớp',
                    noContext: 'Không có thông tin ngữ cảnh học sinh.',
                    childProfileNotFound: 'Không tìm thấy hồ sơ học sinh trong hệ thống cho tài khoản hiện tại.',
                    loginProfileIncomplete: 'Hồ sơ đăng nhập chưa có đầy đủ thông tin ngữ cảnh học sinh.',
                    educationContextNotFound: 'Đã tìm thấy hồ sơ học sinh, nhưng chưa có phân công chương trình học.',
                    noToken: 'Không tìm thấy học sinh đã đăng nhập.'
                },
                errors: {
                    signInRequired: 'Vui lòng đăng nhập để xem chương trình học.',
                    appIdMissing: 'Thiếu ID ứng dụng.',
                    loadFailed: 'Không thể tải dữ liệu chương trình học.'
                }
            }
    };
